import { render, staticRenderFns } from "./InterpreterInfo.vue?vue&type=template&id=4dac6c63&scoped=true&"
import script from "./InterpreterInfo.vue?vue&type=script&lang=js&"
export * from "./InterpreterInfo.vue?vue&type=script&lang=js&"
import style0 from "./InterpreterInfo.vue?vue&type=style&index=0&id=4dac6c63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dac6c63",
  null
  
)

export default component.exports